<mat-drawer-container
  [hasBackdrop]="true"
  class="relative"
  (backdropClick)="onBackdropClick()">
  <mat-drawer
    #drawer
    mode="over"
    position="end"
    [disableClose]="true"
    (closed)="!disableClose && drawerService.closeDrawerWithCallback()"
    [autoFocus]="false">
    <div class="h-full overflow-hidden px-[1.5rem] pb-[1.5rem] pt-[2rem]">
      <div class="close-button">
        <button
          tabIndex="-1"
          class=""
          mat-icon-button
          (click)="!disableClose && drawerService.closeDrawerWithCallback()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <ng-template #drawerContent></ng-template>
    </div>
  </mat-drawer>
  <ng-content></ng-content>
</mat-drawer-container>
